module.exports = __webpack_public_path__ + "static/media/WETHe.946772ab.svg";